<template>
  <main>
    <md-steppers md-active-step="start" md-alternative md-linear>
      <md-step id="email" md-label="メール認証"></md-step>
      <md-step id="apply" md-label="必須事項の入力"></md-step>
      <md-step id="start" md-label="無料トライアルご利用開始"></md-step>
    </md-steppers>

    <div class="md-layout md-alignment-center">
      <div class="md-layout-item md-size-90 md-small-size-100">
        <h2 class="md-title">無料トライアルのお申し込みが完了しました。</h2>
        <p>この度はシカクマップの無料トライアルをお申込みいただき、誠にありがとうございます。<br>
          ご登録いただいたメールアドレスへ当サービスのIDとパスワードを送信いたしました。
          無料トライアル期間中にぜひ、シカクマップをご利用ください。
        </p>
      </div>
    </div>

    <div class="md-layout md-alignment-center">
      <md-card class="md-layout-item md-size-90 md-small-size-100">
        <md-card-actions class="md-layout">
          <div class="md-layout-item md-size-20 md-layout md-alignment-center-left">
          </div>
          <div class="md-layout-item md-size-60 md-layout md-alignment-center-center">
            <router-link :to="{name: 'MapLogin'}" class="md-raised md-primary" tag="md-button">
              <span>シカクマップ　ログイン画面へ</span>
              <md-icon>arrow_right</md-icon>
            </router-link>
          </div>
          <div class="md-layout-item md-size-20 md-layout md-alignment-center-right">
          </div>
        </md-card-actions>
      </md-card>
    </div>
  </main>
</template>

<script>
import Common from "../../modules/common";

export default {
  name   : "TrialStart",
  data   : () => ({}),
  mounted: function () {
    const requestSuccess = localStorage.getItem(Common.localStorageKeys.requestSuccess);
    if (_.isEmpty(requestSuccess)) {
      this.$router.replace({name: 'TrialEmail'});
      return;
    }
    localStorage.removeItem(Common.localStorageKeys.requestSuccess);
    localStorage.removeItem(Common.localStorageKeys.user.accessToken);
    localStorage.removeItem(Common.localStorageKeys.user.accessTokenExpireIn);
    localStorage.removeItem(Common.localStorageKeys.user.auth);
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/components";

.md-steppers {
  height: 104px;
}

.md-stepper {
  padding: 0;
}

.md-button {
  margin-top: 40px;
  margin-bottom: 40px;
}
</style>
